const templateVariables = {
  name: 'ovensmash',
  locate: 'vn',
  folderUse: [
    'main',
    'ovensmash-26-pre-header',
'ovensmash-26-pre-pregister',
'ovensmash-26-pre-milestone',
'ovensmash-26-pre-prize',,
'ovensmash-26-pre-testPer',
'ovensmash-26-pre-story',
'ovensmash-26-pre-store',
'ovensmash-26-pre-social',
'ovensmash-26-pre-intro',
'ovensmash-26-pre-logo',
'ovensmash-26-pre-overview',
'ovensmash-26-pre-contact',
'ovensmash-26-pre-footer',
'ovensmash-26-pre-bottom',
'ovensmash-26-pre-navigation',
'libraryMainsite-t-popup',
'libraryMainsite-t-article'

  ],
  generateFile: ['index','article', 'index-id', 'index-vn', 'index-cn', 'index-th'],
  H5: false,
  onlyPC: false,
  scaleWidthPC: 2000,
  scaleWidthMB: 768,
  scaleWidthMB2: 550,
  scssVariable: {
    minWidthPC: '769px',
    maxWidthMB: '768px',
  },
  separateFiles: {
    article: {
      files: ['main','libraryMainsite-t-article'],
      name: 'article'
    },
    // frame3: {
    //   files: ['main','vxphl-ld-25-a-milestone', 'libraryMainsite-t-popup'],
    //   name: 'frame3'
    // }
  },
};

module.exports = templateVariables;